<template>
  <div class="flex -mr-2 md:hidden">
    <button
      @click="$emit('toggle')"
      class="inline-flex items-center justify-center p-2 text-gray-200 rounded-md hover:text-white hover:bg-gray-900 focus:outline-none focus:bg-gray-800 focus:text-white"
    >
      <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
        <path
          :class="{ 'hidden': isOpen, 'inline-flex': !isOpen }"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />

        <path
          :class="{ 'hidden': !isOpen, 'inline-flex': isOpen }"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: { type: Boolean, required: true },
  },
}
</script>
